<div class="patrol-signin-form">
  <form [formGroup]="signinForm">
    <app-input-field
      formControlName="userName"
      [label]="'app.auth.userName' | translate"
      [inputType]="'input'"
      [type]="'text'"
      [validationErrors]="{
        required: ('app.auth.requiredUserName' | translate),
        pattern: ('app.auth.validUserName' | translate)
      }"
      (keydown.enter)="onSubmit()"
    ></app-input-field>

    <app-input-field
      formControlName="password"
      [label]="'app.auth.password' | translate"
      [inputType]="'input'"
      [type]="'password'"
      [validationErrors]="{
        required: ('app.auth.requiredPassword' | translate)
      }"
      (keydown.enter)="onSubmit()"
    ></app-input-field>

    <div class="patrol-signin-form__actions">
      <app-cta-button
        [loading]="requestPending()"
        [disabled]="!signinForm.valid"
        (clicked)="onSubmit()"
      >
        <span cta-label>{{ 'app.auth.signIn' | translate }}</span>
      </app-cta-button>
    </div>
  </form>
</div>
